import styled from 'styled-components';
import theme from '../../../../../styles/theme';
import NaviText from '../../../common/NaviText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Button from '../../../../common/Button';
import { useGetItemSel } from '../../../../../interface/item';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Collapse, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useGetInoutHistSel, useSetInoutHist } from '../../../../../interface/inout';
import { useGetCodeList } from '../../../../../interface/common';
import CommonDataGrid from '../../../../common/CommonDataGrid';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCallback } from 'react';
import { Row, TabText } from '../../../../../styles/common';
import { NumericFormat } from 'react-number-format';

const MainWrap = styled.div`
    position: relative;
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }

`;

const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}

const columns = [
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_nm', headerName: '모델명', width:300 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1', headerName: '책임자', width:100 },
    { field: 'uid2', headerName: ' 부책임자', width:100 },
]

const inoutColumns = [
    { field: 'tno', headerName: '자산번호', flex:1 },
    { field: 'cat_nm', headerName: '분류', flex: 0.5 },
    { field: 'model_nm', headerName: '모델명', flex: 1 },
    // { field: 'o_ret_stnm', headerName: '반출상태', flex:0.5 },
    { field: 'o_reg_dt', headerName: '반출일', flex:1 },
    { field: 'i_ret_stnm', headerName: '반입상태', flex:0.5 },
    { field: 'i_reg_dt', headerName: '반입일', flex:1 },
]

const RelItem = ({target : paramTarget, onClose}) => {

    const [listMode, setListMode] = useState('ALL');
    const [list, setList] = useState([]);
    const [inoutList, setInoutList] = useState([]);
    const [inWaitList, setInWaitList] = useState([]);
    const [itemToggle, setItemToggle] = useState(false);

    const [target, setTarget] = useState(paramTarget);
    const [mode, setMode] = useState();

    const [showOdetail, setShowODetail] = useState((paramTarget && !paramTarget.i_seq) ? true : false);
    const [showIdetail, setShowIDetail] = useState((paramTarget && paramTarget.i_seq) ? true : false);

    const { data : ioRetStList} = useGetCodeList('io_ret_st');
    const { data : itemList, isLoading:itemLoading } = useGetItemSel({cid:37});
    // const { data : inoutHistList, isLoading: inoutHistLoading } = useGetInoutHistSel({sno:sno});
    // const { mutate } = useSetInoutHist();

    useEffect(()=>{
        if(itemList){
            setList(itemList.map((item,index)=>({...item,id:index})));
        }else{
            setList([])
        }
    },[itemList])

    const handleValueChange = (id, val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    return (
        <MainWrap>
            <div className='naviBar'>
                {/* <NaviText target={['ASSET','반입반출',iotNm,'자산정보']} /> */}
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <Row col={5} style={{marginTop:'8px'}}>
                <TextField
                    id='tno' 
                    label='자산번호' 
                    size='small' 
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    disabled
                    value={target && target.tno}
                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
                <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        InputProps={{
                            readOnly: true,
                        }}
                        InputLabelProps={{shrink:true}} 
                        disabled
                        value={target && target.model_nm}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                <TextField
                    label='분류'
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    size='small'
                    disabled
                    // placeholder='분류'
                    value={target && target.cat_nm}
                />
            </Row>
            
            
            
            <Row>
                <MenuOpenIcon onClick={()=>setItemToggle(!itemToggle)}/>
                자산검색 
                {itemToggle === true &&
                    <React.Fragment>
                        &nbsp;&nbsp;&nbsp;&gt;&gt;
                        <TabText selected={listMode === 'ALL'} onClick={()=>setListMode('ALL')}>전체자산</TabText>
                        <TabText selected={listMode === 'IN_OUT'} onClick={()=>setListMode('IN_OUT')}>현황</TabText>
                        <TabText selected={listMode === 'IN_WAIT'}onClick={()=>setListMode('IN_WAIT')}>반입대상</TabText>
                    </React.Fragment>
                }

            </Row>
            <Collapse in={itemToggle} >
                <CommonDataGrid
                    isLoading={itemLoading}
                    list={listMode==='ALL' ? list : listMode === 'IN_WAIT' ? inWaitList : inoutList}
                    columns={listMode === 'ALL' ? columns : inoutColumns}
                    // onRowClick={(e)=>{handleItemClick(e.row)}}
                    />
            </Collapse>
        </MainWrap>
    )
}

export default RelItem;